import axios from 'axios';
import { BASEURL } from '../../baseUrl';
import { toast } from 'react-toastify';

export const CREATE_WADADDY_CREDENTIAL = 'CREATE_WADADDY_CREDENTIAL';
export const UPDATE_WADADDY_CREDENTIAL = 'UPDATE_WADADDY_CREDENTIAL';
export const GET_WADADDY_CREDENTIAL = 'GET_WADADDY_CREDENTIAL';
export const GET_WADADDY_BALANCE = 'GET_WADADDY_BALANCE';

const createWaDaddyCredentialAction = (payload) => ({
  type: CREATE_WADADDY_CREDENTIAL,
  payload,
});
const updateWaDaddyCredentialAction = (payload) => ({
  type: UPDATE_WADADDY_CREDENTIAL,
  payload,
});
const getWaDaddyCredentialAction = (payload) => ({
  type: GET_WADADDY_CREDENTIAL,
  payload,
});
const getWaDaddyBalanceAction = (payload) => ({
  type: GET_WADADDY_BALANCE,
  payload,
});

export const createWaDaddyCredential = (id, data) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.post(
        `${BASEURL}/chatbox/credential/create/${id}`,
        data,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (res?.data?.data?._id) {
        toast.success('WhatsApp API credentials saved successfully');
      } else {
        toast.error(
          res?.data?.data?.message || 'Failed to save WhatsApp API credentials',
        );
      }
      dispatch(createWaDaddyCredentialAction(res));
      return res;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          'Something went wrong while saving WhatsApp credentials',
      );
      dispatch(createWaDaddyCredentialAction(error?.response));
      return error?.response;
    }
  };
};

export const updateWaDaddyCredential = (credentialId, data) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.put(
        `${BASEURL}/chatbox/credential/update/${credentialId}`,
        data,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (res?.data?.data?._id) {
        toast.success('WhatsApp API credentials updated successfully');
      } else {
        toast.error('WhatsApp API credentials could not be updated');
      }
      dispatch(updateWaDaddyCredentialAction(res));
      return res;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          'Something went wrong while updating WhatsApp credentials',
      );
      dispatch(updateWaDaddyCredentialAction(error?.response));
      return error?.response;
    }
  };
};

export const getWaDaddyCredential = (id) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      const url = id
        ? `${BASEURL}/chatbox/credential/getOne/${id}`
        : `${BASEURL}/chatbox/credential/get`;
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      dispatch(getWaDaddyCredentialAction(res));
      return res;
    } catch (error) {
      dispatch(getWaDaddyCredentialAction(error?.response));
      return error?.response;
    }
  };
};

export const getWaDaddyBalance = () => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${BASEURL}/chatbox/credential/balance`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      dispatch(getWaDaddyBalanceAction(res));
      return res;
    } catch (error) {
      dispatch(getWaDaddyBalanceAction(error?.response));
      return error?.response;
    }
  };
};
